import React from "react";
import SoftBox from "components/SoftBox";
import SoftModal from "components/SoftModal";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { Autocomplete, TextField } from "@mui/material";
import { timezoneOptions } from "utils/timeZoneData";
// i18n
import { useTranslation } from "react-i18next";

const DefaultTimeZone = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [timezone, setTimezone] = React.useState("UTC");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSave = () => {
    localStorage.setItem("timezone", timezone);
    window.dispatchEvent(
      new CustomEvent("localStorageChanged", {
        detail: {
          key: "timezone",
          newValue: timezone,
        },
      })
    );
    handleClose();
  };

  const handleCancel = () => {
    setTimezone(localStorage.getItem("timezone") || "UTC");
    window.dispatchEvent(
      new CustomEvent("localStorageChanged", {
        detail: {
          key: "timezone",
          newValue: timezone,
        },
      })
    );
    handleClose();
  };

  React.useEffect(() => {
    const saved = localStorage.getItem("timezone");
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (saved) {
      setTimezone(saved);
    } else {
      setTimezone(userTimezone);
      localStorage.setItem("timezone", userTimezone);
    }
  }, []);

  return (
    <SoftBox>
      <SoftButton variant="gradient" color="warning" fullWidth onClick={handleOpen}>
        <SoftBox></SoftBox>
        <SoftTypography variant="p" color="white" mr={1}>
          {t("timezone.button")}
        </SoftTypography>
      </SoftButton>
      <SoftModal
        width={"35%"}
        title={t("timezone.modal_title")}
        description={t("timezone.modal_description")}
        open={open}
        handleClose={handleClose}
      >
        <SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                {t("timezone.label")}
              </SoftTypography>
            </SoftBox>
            <Autocomplete
              value={timezoneOptions.find((opt) => opt.value === timezone) || null}
              onChange={(_, newValue) => {
                if (newValue) {
                  setTimezone(newValue.value);
                }
              }}
              options={timezoneOptions}
              getOptionLabel={(option) => option.label}
              disableClearable
              sx={{ width: 250 }}
              renderInput={(params) => (
                <TextField {...params} placeholder={t("timezone.placeholder")} />
              )}
            />
          </SoftBox>
          <SoftBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={1}>
            <SoftButton
              onClick={handleSave}
              style={{
                width: 120,
              }}
              variant="gradient"
              color="warning"
            >
              {t("timezone.save")}
            </SoftButton>

            <SoftButton
              onClick={handleCancel}
              style={{
                width: 120,
              }}
              variant="gradient"
              color="warning"
            >
              {t("timezone.cancel")}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftModal>
    </SoftBox>
  );
};

export default DefaultTimeZone;
